import { NgModule } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {
  NgCustomFormsModule,
  PatientDetailsFormService,
} from '@principle-theorem/ng-custom-forms';
import { NgInteractionsModule } from '@principle-theorem/ng-interactions';
import { NgLabsModule } from '@principle-theorem/ng-labs';
import { NgMaterialModule } from '@principle-theorem/ng-material';
import { NgPrincipleAccountingModule } from '@principle-theorem/ng-principle-accounting';
import { NgPrincipleSharedModule } from '@principle-theorem/ng-principle-shared';
import { NgSharedModule } from '@principle-theorem/ng-shared';
import { NgTasksModule } from '@principle-theorem/ng-tasks';
import { AddPatientComponent } from './add-patient/add-patient.component';
import { CopyPatientIdButtonComponent } from './copy-patient-id-button/copy-patient-id-button.component';
import { CreatePatientDocumentDialogComponent } from './create-patient-document-dialog/create-patient-document-dialog.component';
import { DeletePatientButtonComponent } from './delete-patient-button/delete-patient-button.component';
import { DVACardFormComponent } from './dva-card-form/dva-card-form.component';
import { EditDVACardComponent } from './edit-dva-card/edit-dva-card.component';
import { EditHealthFundCardComponent } from './edit-healthfund-card/edit-healthfund-card.component';
import { EditMedicareCardComponent } from './edit-medicare-card/edit-medicare-card.component';
import { EditPatientFormComponent } from './edit-patient-form/edit-patient-form.component';
import { HealthInsuranceDetailsFormComponent } from './health-insurance-details-form/health-insurance-details-form.component';
import { MedicareCardFormComponent } from './medicare-card-form/medicare-card-form.component';
import { MergePatientButtonComponent } from './merge-patient-button/merge-patient-button.component';
import { MergePatientDialogComponent } from './merge-patient-dialog/merge-patient-dialog.component';
import { PatientAddressComponent } from './patient-address/patient-address.component';
import { PatientDocumentComponent } from './patient-document/patient-document.component';
import { PatientDocumentsComponent } from './patient-documents/patient-documents.component';
import { PatientGapOfferDetailsComponent } from './patient-gap-offer/patient-gap-offer-details/patient-gap-offer-details.component';
import { PatientGapOfferComponent } from './patient-gap-offer/patient-gap-offer.component';
import { PatientGapOfferService } from './patient-gap-offer/patient-gap-offer.service';
import { PatientHealthcareInformationComponent } from './patient-healthcare-information/patient-healthcare-information.component';
import { PatientAgeComponent } from './patient-information/patient-age/patient-age.component';
import { PatientDateOfBirthComponent } from './patient-information/patient-date-of-birth/patient-date-of-birth.component';
import { PatientFeeScheduleComponent } from './patient-information/patient-fee-schedule/patient-fee-schedule.component';
import { PatientGenderComponent } from './patient-information/patient-gender/patient-gender.component';
import { PatientLastVisitComponent } from './patient-information/patient-last-visit/patient-last-visit.component';
import { PatientInteractionsComponent } from './patient-interactions/patient-interactions.component';
import { PatientLabJobsComponent } from './patient-lab-jobs/patient-lab-jobs.component';
import { PatientMedicalAlertsComponent } from './patient-medical-alerts/patient-medical-alerts.component';
import { PatientMedicalHistoryComponent } from './patient-medical-history/patient-medical-history.component';
import { PatientMedicalHistoryService } from './patient-medical-history/patient-medical-history.service';
import { PatientPhoneComponent } from './patient-phone/patient-phone.component';
import { PatientPrescriptionFormComponent } from './patient-prescriptions/patient-prescription-form/patient-prescription-form.component';
import { PatientPrescriptionsListComponent } from './patient-prescriptions/patient-prescriptions-list/patient-prescriptions-list.component';
import { PrescriptionItemFormComponent } from './patient-prescriptions/prescription-item-form/prescription-item-form.component';
import { PatientPrimaryContactFormComponent } from './patient-primary-contact-form/patient-primary-contact-form.component';
import { PatientReferrerComponent } from './patient-referrer/patient-referrer.component';
import { PatientRelationshipDialogComponent } from './patient-relationship-dialog/patient-relationship-dialog.component';
import { PatientRelationshipFormComponent } from './patient-relationship-form/patient-relationship-form.component';
import { PatientRelationshipListComponent } from './patient-relationship-list/patient-relationship-list.component';
import { PatientRelationshipsCardComponent } from './patient-relationships-card/patient-relationships-card.component';
import { PatientTasksComponent } from './patient-tasks/patient-tasks.component';
import { PatientViewInvoiceTransactionComponent } from './patient-view-invoice/patient-view-invoice-transaction/patient-view-invoice-transaction.component';
import { PatientViewInvoiceComponent } from './patient-view-invoice/patient-view-invoice.component';
import { PatientViewInvoiceService } from './patient-view-invoice/patient-view-invoice.service';
import { UpdatePatientComponent } from './update-patient/update-patient.component';
import { MohService } from '@principle-theorem/ng-funding-requests';
import { PatientFirestoreButtonComponent } from './patient-firestore-button/patient-firestore-button.component';

@NgModule({
  imports: [
    NgMaterialModule,
    MatSlideToggleModule,
    NgSharedModule,
    NgPrincipleSharedModule,
    NgInteractionsModule,
    NgLabsModule,
    NgTasksModule,
    NgCustomFormsModule,
    NgPrincipleAccountingModule,
    PatientPrescriptionsListComponent,
    PrescriptionItemFormComponent,
    PatientPrescriptionFormComponent,
    PatientHealthcareInformationComponent,
    HealthInsuranceDetailsFormComponent,
    PatientLastVisitComponent,
    PatientMedicalAlertsComponent,
    PatientDocumentsComponent,
  ],
  declarations: [
    MedicareCardFormComponent,
    PatientDocumentComponent,
    CreatePatientDocumentDialogComponent,
    PatientAgeComponent,
    PatientDateOfBirthComponent,
    PatientGenderComponent,
    CopyPatientIdButtonComponent,
    UpdatePatientComponent,
    EditPatientFormComponent,
    PatientAddressComponent,
    DVACardFormComponent,
    PatientPhoneComponent,
    PatientRelationshipsCardComponent,
    PatientLabJobsComponent,
    PatientTasksComponent,
    PatientRelationshipListComponent,
    PatientRelationshipDialogComponent,
    EditMedicareCardComponent,
    EditHealthFundCardComponent,
    EditDVACardComponent,
    PatientRelationshipFormComponent,
    PatientMedicalHistoryComponent,
    PatientReferrerComponent,
    PatientPrimaryContactFormComponent,
    PatientInteractionsComponent,
    PatientViewInvoiceComponent,
    PatientFeeScheduleComponent,
    PatientGapOfferComponent,
    PatientGapOfferDetailsComponent,
    PatientViewInvoiceTransactionComponent,
    MergePatientDialogComponent,
    MergePatientButtonComponent,
    DeletePatientButtonComponent,
    AddPatientComponent,
    PatientFirestoreButtonComponent,
  ],
  exports: [
    MedicareCardFormComponent,
    PatientDocumentsComponent,
    PatientDocumentComponent,
    CreatePatientDocumentDialogComponent,
    PatientAgeComponent,
    PatientDateOfBirthComponent,
    PatientGenderComponent,
    PatientLastVisitComponent,
    CopyPatientIdButtonComponent,
    EditPatientFormComponent,
    PatientAddressComponent,
    DVACardFormComponent,
    PatientPhoneComponent,
    PatientRelationshipsCardComponent,
    PatientLabJobsComponent,
    PatientTasksComponent,
    PatientRelationshipListComponent,
    PatientRelationshipDialogComponent,
    EditMedicareCardComponent,
    EditHealthFundCardComponent,
    EditDVACardComponent,
    PatientRelationshipFormComponent,
    PatientMedicalAlertsComponent,
    PatientReferrerComponent,
    PatientPrimaryContactFormComponent,
    PatientInteractionsComponent,
    PatientFeeScheduleComponent,
    MergePatientButtonComponent,
    DeletePatientButtonComponent,
    PatientPrescriptionsListComponent,
    PrescriptionItemFormComponent,
    PatientPrescriptionFormComponent,
    PatientHealthcareInformationComponent,
    HealthInsuranceDetailsFormComponent,
    AddPatientComponent,
    PatientFirestoreButtonComponent,
  ],
  providers: [
    PatientMedicalHistoryService,
    PatientDetailsFormService,
    PatientViewInvoiceService,
    PatientGapOfferService,
    MohService,
  ],
})
export class ComponentsModule {}
